import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper(".js-searchSwiper", {
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      centeredSlides: true,
    },
  },
  centeredSlides: false,
  loop: true,
  navigation: {
    nextEl: ".js-searchSwiper .swiper-button-next",
    prevEl: ".js-searchSwiper .swiper-button-prev",
  },
  pagination: {
    clickable: true,
    el: ".js-searchSwiper .swiper-pagination",
  },
  slidesPerView: "auto",
  spaceBetween: 0,
});
